import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';

// project import
import DrawerHeaderStyled from './DrawerHeaderStyled';
import { Link } from 'react-router-dom';
import { getRootURL } from '../../../../../helper/Utility';
import LogoCom from '../../../../../components/LogoCom';
export default function DrawerHeader({ open }) {
  const theme = useTheme();
  return (
    <DrawerHeaderStyled theme={theme} open={!!open} className='outer-logo'>
      <Link to={`/${getRootURL()}/dashboard`} className="sidebar_logo mt-3 text-center mx-auto">
        <LogoCom />
      </Link>
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
